<template>
  <div>
    <v-data-table
      :headers="[
        {text: 'Av', width: '175px', sortable: true, filterable: false, value: 'createdById'},
        {text: 'Tidpunkt', width: '175px', sortable: true, filterable: false, value: 'createdAt'},
        {text: 'Anteckning', sortable: false, filterable: false, value: 'data'},
        {text: 'Kopplade Ärenden', width: '175px', sortable: false, filterable: false, value: 'noteableId'},
        {text: 'Radera', sortable: false, filterable: false, value: 'actions', align: 'center'}]"
      :items="allNotes"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalRows"
      :items-per-page="itemsPerPage"
      item-key="id"
    >

    <template slot="item.createdById" slot-scope="props">
      {{ _get(props, 'item.createdBy.firstName', '') }} {{ _get(props, 'item.createdBy.lastName', '') }}
    </template>

    <template slot="item.createdAt" slot-scope="props">
      {{ _get(props, 'item.createdAt', null) | datetime }}
    </template>

    <template slot="item.noteableId" slot-scope="props">
      <div v-if="_get(props, 'item.noteableId', null)">
        <router-link v-show="_get(props, 'item.noteableType', null) == 'Application'" :to="'/applications/' + props.item.noteableId">
          Lärlingsanmälan {{ props.item.noteableId }}
        </router-link>
      </div>
    </template>

    <template slot="item.actions" slot-scope="props" v-if="_get(props, 'item.commentableType', null) !== 'DistanceOrder'">
      <v-btn text @click="deleteNote(props.item)"><v-icon>$sl-delete</v-icon></v-btn>
    </template>

    </v-data-table>

  </div>
</template>

<script>
import API from '@/services/api.js'
import { mapGetters, mapActions } from 'vuex'
import { pageSize } from '@/store/constants'
import _get from 'lodash/get'
import { CanIDo } from '@/components/mixins'
import get from 'lodash/get'

export default {
  mixins: [CanIDo],

  props: {
    modifier: {
      type: Object,
      detault: {}
    },
    search: {
      type: String
    },
    refresh: {
      type: Boolean
    },
    comments: {
      type: Array,
      default: () => ([])
    },
    isCompanyNote: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    notes: [],
    options: {},
    itemsPerPage: pageSize,
    notesModal: false
  }),

  computed: {
    ...mapGetters('app', ['isLoading']),

    allNotes() {
      return [ 
        ...this.notes, 
        ...this.comments.map(c => { return { ...c, data: c.content } }) 
      ] || []
    },

    totalRows() {
      return this.allNotes.length
    }
  },

  asyncComputed: {
    canDeleteNotes(){
      return this.canIDo('notes', 'delete');
    },
  },

  watch: {
    options: {
      handler(val) {
        this.fetchNotes()
      },
      deep: true
    },
    modifier: {
      handler(newVal,oldVal) {
        if (newVal && oldVal && 
          newVal.applicationId && oldVal.applicationId &&
          newVal.applicationId === newVal.applicationId) return
        if (newVal && oldVal && 
          newVal.personId && oldVal.personId &&
          newVal.personId === newVal.personId) return

        this.fetchNotes()
      },
      deep: true
    },
    search: {
      handler(val) {
        this.fetchNotes()
      }
    },
    refresh: {
      handler(val) {
        console.log('ref ', val)
        this.fetchNotes()
      }
    }
  },

  created() {
    this.fetchNotes()
  },

  methods: {

    _get : _get,

    async deleteNote(item) {
      const res = await this.$dialog.confirm({
        text: _get(item, 'data', ''),
        title: 'VILL DU RADERA ANTECKNINGEN?',
        actions: [
          {text: 'AVBRYT', key: false, icon: '$sl-cancel'},
          {text: 'RADERA', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) return

      API.deleteNote (item.id)
      .then(() => {
        this.fetchNotes()
      })
      .catch(error => {
        console.log('There was an error:', error)
        this.$events.fire('showError', _get(error, 'response.data.message','Kunde inte radera anteckningen'))
      })
    },

    fetchNotes() {
      
      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      const startAt = (page - 1) * this.itemsPerPage
      let advSearch = { personId: this.modifier?.personId }

      if ( this.isCompanyNote ) {
        advSearch = { notableType: 'Company', companyId: Number(get(this, '$route.params.id', null)) }
      }

      API.listNotes ({
        startAt: startAt ? startAt : 0,
        sortBy: sortBy ? sortBy[0] : 'createdAt',
        sortDesc: sortDesc ? sortDesc[0] : 'DESC',
        search: this.search,
        advSearch,
        pageSize: this.itemsPerPage
      })
      .then(response => this.notes = response.data.rows)
      .catch(error => {
        console.log('There was an error:', error.response)
      })
      
    }
  }

}
</script>

<style>
  td.text-start, td.text-center {
    vertical-align: top;
  }
  td.text-start {
    padding-top: 14px !important;
  }
</style>